import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import styles from './AddTErmsConditions.module.scss';
import Toggle from 'component/atom/forms/toggle/Toggle';
import RadioGroup from 'component/atom/forms/radio-group/RadioGroup';
import Container from 'component/atom/container/Container';
import { FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import Loader from 'component/atom/loader/Loader';
import TextEditor from 'component/atom/forms/text-editor/TextEditor';

const AddTermsConditions = forwardRef(
  ({ id, termsConditions, isFetching, botData }, ref) => {
    const options = [
      { label: 'First Time', value: '0' },
      { label: 'Every Time', value: '1' },
    ];

    const validationSchema = Yup.object({
      forceAcceptInLogin: Yup.boolean()
        .required('forceAcceptInLogin is Required')
        .nullable(),
      termsConditions: Yup.string().required('termsConditions is Required'),
      termsFrequency: Yup.number().required('termsFrequency is Required'),
    });

    const formik = useFormik({
      initialValues: {
        forceAcceptInLogin: termsConditions?.data?.forceAcceptInLogin || false,
        termsConditions: termsConditions?.data?.termsConditions || '',
        termsFrequency: termsConditions?.data?.termsFrequency?.toString(),
      },
      validationSchema: validationSchema,
      enableReinitialize: true,
      onSubmit: (values) => {},
    });

    useImperativeHandle(ref, () => ({
      submitForm: () => {
        formik.submitForm();
      },
    }));

    useEffect(() => {
      ref.current = formik;
    }, [ref, formik]);

    if (isFetching) {
      return <Loader isComponent />;
    }

    return (
      <FormikProvider value={formik} innerRef={ref}>
        {1 === botData?.type && (
          <Container>
            <Toggle
              label='Force Accept in Login'
              left
              name='forceAcceptInLogin'
              value={formik.values.forceAcceptInLogin}
              onChange={formik.handleChange}
              error={formik.errors.forceAcceptInLogin}
              touched={formik.touched.forceAcceptInLogin}
            />
            <RadioGroup
              options={options}
              name='termsFrequency'
              selectedValue={formik.values.termsFrequency}
              onChange={(e) => {
                formik.setFieldValue('termsFrequency', e.target.value);
              }}
              error={formik.errors.termsFrequency}
              touched={formik.touched.termsFrequency}
            />
          </Container>
        )}

        <Container>
          <TextEditor
            label='Add Terms and Conditions'
            placeholder='Enter Terms and Condition'
            name='termsConditions'
            value={formik.values.termsConditions}
            onChange={(value) => {
              formik.setFieldValue('termsConditions', value);
            }}
            error={formik.errors.termsConditions}
            touched={formik.touched.termsConditions}
            isToolbarReduced
            textEditorClassName={styles['text-editor-terms']}
          />
        </Container>
      </FormikProvider>
    );
  }
);

export default AddTermsConditions;
